import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { setProgram } from '../utils';
import ActivationQuestion from './ActivationQuestion';
import OVIDClient from '../OVIDClient';
import update from '../../../utils/objects/update';
import updateArray from '../../../utils/array/update';
import validDate from '../../../utils/strings/validDate';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { jsxs as _jsxs } from "react/jsx-runtime";
var moduleClass = 'account-team';

var TeamPreActivation = function TeamPreActivation(_ref) {
  var profileQuestions = _ref.profileQuestions,
      preActivationDescription = _ref.preActivationDescription,
      preActivationTitle = _ref.preActivationTitle,
      programId = _ref.programId;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      fetching = _useState2[0],
      setFetching = _useState2[1];

  var _useState3 = useState(profileQuestions),
      _useState4 = _slicedToArray(_useState3, 2),
      answers = _useState4[0],
      setAnswers = _useState4[1];

  var onAnswer = function onAnswer(event, idx) {
    var answer = answers[idx];
    var newAnswers = updateArray(answers, idx, update(answer, {
      response: event.target.value
    }));
    setAnswers(newAnswers);
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var responses, query, client, email, colorQuery, colorResponse, _colorResponse$data, programs, schoolColor;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              responses = {};
              answers.forEach(function (answer) {
                responses[answer.name] = answer.response;
              });
              setFetching(true);
              query = "\n    mutation UserProgramCreate($programId: String!, $answers: String!) {\n      userProgramCreate(programId: $programId, answers: $answers) {\n        id\n        program {\n          id\n          title\n          postActivationDescription\n          postActivationTitle\n          postActivationCTA\n          postActivationURL\n        }\n      }\n    }";
              client = new OVIDClient();
              _context.next = 8;
              return client.mutate(query, {
                programId: programId,
                answers: JSON.stringify(responses)
              });

            case 8:
              email = window.OV.CUSTOMER.email;
              colorQuery = "query Color {\n      programs {\n        id\n        promoCode\n      }\n      schoolColor(email: \"".concat(email, "\") {\n        id\n        primaryColor\n        secondaryColor\n        name\n      }\n    }");
              _context.next = 12;
              return client.query(colorQuery);

            case 12:
              colorResponse = _context.sent;
              _colorResponse$data = colorResponse.data, programs = _colorResponse$data.programs, schoolColor = _colorResponse$data.schoolColor;
              setProgram(_objectSpread(_objectSpread({}, schoolColor), {}, {
                promoCode: programs[0].promoCode
              }));
              setFetching(false);
              window.location.reload();

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var answered = function answered() {
    var valid = true;
    answers.forEach(function (answer) {
      valid = valid && validAnswer(answer);
    });
    return valid;
  };

  var validAnswer = function validAnswer(answer) {
    var response = answer.response,
        type = answer.question_type;
    var valid = response && response !== '';

    if (type === 'D') {
      valid = valid && validDate(response);
    }

    return valid;
  };

  var isAnswered = answered();
  var buttonClass = cc(["".concat(moduleClass, "__button"), _defineProperty({}, "".concat(moduleClass, "__button--disabled"), !isAnswered || fetching)]);
  var disabled = !isAnswered || fetching;
  return /*#__PURE__*/_jsxs("section", {
    className: moduleClass,
    "aria-busy": fetching,
    children: [/*#__PURE__*/_jsx("h1", {
      className: "".concat(moduleClass, "__title"),
      dangerouslySetInnerHTML: {
        __html: preActivationTitle
      }
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(moduleClass, "__description"),
      dangerouslySetInnerHTML: {
        __html: preActivationDescription
      }
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(moduleClass, "__questions"),
      children: profileQuestions.map(function (question, idx) {
        return /*#__PURE__*/_createElement(ActivationQuestion, _objectSpread(_objectSpread({}, question), {}, {
          idx: idx,
          answer: answers[idx] // eslint-disable-next-line react/no-array-index-key
          ,
          key: "question-".concat(idx),
          moduleClass: moduleClass,
          onAnswer: onAnswer
        }));
      })
    }), /*#__PURE__*/_jsx("button", {
      "aria-busy": fetching,
      className: buttonClass,
      onClick: onSubmit,
      disabled: disabled,
      type: "button",
      children: fetching ? 'Activating' : 'Activate'
    })]
  });
};

TeamPreActivation.propTypes = {
  programId: PropTypes.string.isRequired,
  preActivationDescription: PropTypes.string.isRequired,
  preActivationTitle: PropTypes.string.isRequired,
  profileQuestions: PropTypes.arrayOf(PropTypes.shape()).isRequired
};
export default TeamPreActivation;